import React from "react";
import Modal from "react-bootstrap/Modal";

const ProfileModal = (props) => {
  // console.log("props",props)
  // const [profileModal, setProfileModal] = useState(props.profileModal);
  return (
    <div>
      <Modal
        show={props.profileModal}
        // onHide={profileModalClose}
        onHide={() => props.setProfileModal(false)}
        centered
        size="sm"
      >
        <Modal.Header
          closeButton
          className="modal-header border-0"
          // style={{ padding: "20px 20px 0px 0px" }}
        ></Modal.Header>
        <Modal.Body
          style={{
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
            padding: "10px",
          }}
        >
          <div>
            <p
              style={{
                margin: "0",
                fontSize: "25px",
                fontFamily: "Work sans",
                fontWeight: "600",
              }}
            >
              {props.userInfo.name}
            </p>
            <img
              src={props.userInfo.pic}
              alt="profileImage"
              style={{
                borderRadius: "100%",
                width: "150px",
                margin: "15px",
              }}
            />
            <p>Email: {props.userInfo.email}</p>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
              <Button variant="secondary" onClick={profileModalClose}>
                Close
              </Button>
            </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default ProfileModal;
